<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-form ref="addHsnp" v-model="addHsnpValid">
    <v-card-title :class="{'priority': priority}">
      <span v-if="priority" class="mr-2">{{ this.action }} priority price for:</span>
      <span v-else class="mr-2">{{ this.action }} price for:</span> {{hsnp.hsnp_dag}} {{hsnp.hsnp_datum }} 
    </v-card-title>
    
    <v-container>
    <v-row no-gutters>
      <v-col cols="6" class="px-1">
        <v-select v-model="hsnp.hsnp_van_advb" menu-props="auto" :items="advbKeuzes" item-value="advb_code" item-text="advb_oms" label="Arrival"></v-select>
      </v-col>
      <v-col cols="6" class="px-1">
        <v-select v-model="hsnp.hsnp_tm_advb" menu-props="auto" :items="advbKeuzes" item-value="advb_code" item-text="advb_oms" label="Departure"></v-select>
      </v-col>
    </v-row>  
  
    <v-row no-gutters class="mb-2">
      <v-col cols="4" class="px-1 mr-5">
        <input_amount label="Purchase" :prefix="hsnp.valu_code" :amount="purchase" field="purchase" @updateData="updateData"/>
      </v-col>
      <v-col cols="4" class="px-1">
        <input_amount label="Sales" :prefix="hsnp.valu_code" :amount="sales" field="sales" @updateData="updateData"/>
      </v-col>      
    </v-row>
    <v-row no-gutters class="mb-2">
      <v-col cols="4" class="px-1 mr-5">
        <input_amount label="Minimum purchase" :prefix="hsnp.valu_code" :amount="minpurchase" field="minpurchase" @updateData="updateData"/>
      </v-col>
      <v-col cols="4" class="px-1">
        <input_amount label="Week price" :prefix="hsnp.valu_code" :amount="weekprice" field="weekprice" @updateData="updateData"/>
      </v-col>    
    </v-row>
    <v-row no-gutters class="mb-2">
      <v-col cols="4" class="px-1 mr-5">
        <v-select v-model="hsnp.hsnp_min_aant_nacht" :items="hsnp_min_aant_nachtKeuzes" item-value="hsnp_min_aant_nacht" item-text="hsnp_min_aant_nachtOms" label="Minimal number of nights" dense></v-select>
      </v-col>
      <v-col cols="4" class="px-1" v-if="hsnp.hsnp_tm_tijd1 > 0">
        <v-select v-model="hsnp.hsnp_schoonmaak" :items="hsnp_schoonmaakKeuzes" item-value="hsnp_schoonmaak" item-text="hsnp_schoonmaakOms" label="Number of nights for cleaning" dense></v-select>
      </v-col>
    </v-row>
    <v-row no-gutters class="mb-2">
      <v-col cols="12" class="px-1">
        <v-select v-model="hsnp.hsnp_planning" :items="hsnp_planningKeuzes" item-value="hsnp_planning" item-text="hsnp_planningOms" label="Planning" dense></v-select>
      </v-col>
    </v-row>
  </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveHsnp" :disabled="!addHsnpValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
    </v-form>

  </v-card>

</v-dialog>
</template>

<script>

import input_amount from '@/components/ui/input_amount.vue';

export default {
  data() { 
    return {
      dialog: false,
      hsnp_encrid: null,
      priority: false,
      action: '',
      purchase: '',
      minpurchase: '',
      sales: '',
      weekprice: '',
      hsnp: {},
      addHsnpValid: false,
      advbKeuzes: [],
      hsnp_min_aant_nachtKeuzes: [],
      hsnp_planningKeuzes: [],
      hsnp_schoonmaakKeuzes: [],
      intRules: [
        v => /^\d*$/.test(v) || 'The value must be an integer number'
      ]
    }
  },
  created () {
  },
  components: {
    input_amount
  },
  methods: {
    async open(hsnp_encrid, priority, action) {
      this.hsnp_encrid = hsnp_encrid;
      this.priority = priority
      this.action = action
      this.$emit("showSnackbar");
      await this.getHsnp();
      this.dialog = true;           
    },
    async getHsnp(){
      this.$axios
        .post("ares/json/ares/huis/hspt/hsnp/getHsnp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsnp"
          },
          getHsnp: {
            hsnp_encrid: this.hsnp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsnp = res.data.getHsnp;
            this.hsnp_min_aant_nachtKeuzes = res.data.getHsnp.hsnp_min_aant_nachtKeuzes;
            this.hsnp_planningKeuzes = res.data.getHsnp.hsnp_planningKeuzes;
            this.hsnp_schoonmaakKeuzes = res.data.getHsnp.hsnp_schoonmaakKeuzes;
            this.advbKeuzes = res.data.getHsnp.advbKeuzes;     
            this.priority = this.hsnp.hsnp_priority===0&&this.action==='Update'?false:true
            this.purchase = this.formatNumberToString(this.hsnp.hsnp_inkoop)
            this.minpurchase = this.formatNumberToString(this.hsnp.hsnp_min_inkoop)
            this.sales = this.formatNumberToString(this.hsnp.hsnp_verkoop)
            this.weekprice = this.formatNumberToString(this.hsnp.hsnp_weekprijs)
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateData(data){
        console.log(data)
        this[data.field] = data.value
    },
    formatNumberToString(amount){
      return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+amount)
    },
    formatStringToNumber(amount){
      return (amount.replace(".", "")).replace(",", ".")
    },
    saveHsnp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hsnp/saveHsnp2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveHsnp"
          },
          saveHsnp: {
            hsnp_encrid: this.hsnp.hsnp_encrid,
            hspt_encrid: this.hsnp.hspt_encrid,
            hsnp_van_advb: parseInt(this.hsnp.hsnp_van_advb),
            hsnp_tm_advb: parseInt(this.hsnp.hsnp_tm_advb),
            hsnp_inkoop: parseFloat(this.formatStringToNumber(this.purchase)),
            hsnp_verkoop: parseFloat(this.formatStringToNumber(this.sales)),
            hsnp_min_aant_nacht: parseInt(this.hsnp.hsnp_min_aant_nacht),
            hsnp_min_inkoop: parseFloat(this.formatStringToNumber(this.minpurchase)),
            hsnp_weekprijs: parseFloat(this.formatStringToNumber(this.weekprice)),
            hsnp_planning: parseInt(this.hsnp.hsnp_planning),
            hsnp_schoonmaak: parseInt(this.hsnp.hsnp_schoonmaak),
            hsnp_priority: this.priority?1:0
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.saveHsnp.color == "success")
             this.$emit('closeDialog', 'reload')
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveHsnp.text,
              color: res.data.saveHsnp.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

<style scoped> 
.priority{
  color: red;
}
</style>